module.exports = __webpack_public_path__ + "static/media/podium.d5b834e5.svg";